import { render } from "./toggles.vue?vue&type=template&id=609d73a9&scoped=true"
import script from "./toggles.vue?vue&type=script&lang=js"
export * from "./toggles.vue?vue&type=script&lang=js"

import "./toggles.vue?vue&type=style&index=0&id=609d73a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609d73a9"]])

export default __exports__